import { memo } from 'react'
import { useTranslation } from 'react-i18next'

interface MediaPermissionsErrorProps {
  title: string
  description: string
  instruction: string[]
}

const MediaPermissionsError: React.FC<MediaPermissionsErrorProps> = memo(
  ({ title, description, instruction }) => {
    const { t } = useTranslation()
    return (
      <div className="flex flex-col justify-center items-center max-w-[600px]">
        <div className="h-12 w-12 rounded-full bg-red-500 text-white flex items-center justify-center mb-8 text-xl">
          <i className="fa-solid fa-camera" />
        </div>
        <h2 className="text-white text-xl font-semibold text-center mb-4">
          {title}
        </h2>
        <p className="text-white/80 text-center text-sm mb-6 leading-relaxed">
          {description}
        </p>
        <div className="tc-mv-blur flex flex-col items-start self-stretch p-4 px-6 rounded-2xl bg-gray-500/30 text-white mb-2">
          <h3 className="text-white text-sm font-medium mb-3">
            {t('twin.howToEnableAccess')}
          </h3>
          <ul className="space-y-2 text-white/70 text-sm">
            {instruction.map((item, index) => (
              <li key={index} className="flex items-start">
                <span className="mr-2">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  },
)

export { MediaPermissionsError }
